import React, { useEffect } from 'react';
import { HashRouter, useLocation } from 'react-router-dom';
import { AppRouter } from './router';

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
}



/**
 * Adobe App Builder application component
 * @param {Object} props - Component props
 * @param {Object} props.runtime - Adobe Runtime object
 * @param {Object} props.ims - IMS object containing authentication info
 */
function App({ runtime, ims }) {
  // Make runtime and ims available to your application if needed
  // You can access these in your components via React Context if required

  return (
    <HashRouter>
      <ScrollToTop />
      <AppRouter />
    </HashRouter>
  );
}

export default App;
